import {ContentRoute} from "../../../models/Route";
import ChecklistList from "../checklist/checklistList";
import ChecklistForm from "../checklist/checklistForm";
import ChecklistItemForm from "../checklist/checklistItemForm";
import enumDescription from "../../../services/enumDescription";

export interface ChecklistFormData {
    nome: string,
    setor: number,
    ordem: number,
    ativo: boolean,
    versao: number,
    tipo: number,
}

export interface ChecklistItemFormData {
    tipo: number,
    titulo: string,
    obrigatorio:boolean
    draggId: string,
    ordem?: number,
    id?: string,
    descricao?: string,
    tipoMetrica?:number,
    opcoes: Array<OpcoesFormData>,
    config?: Array<CampoFormData> | null,
    secao?: string | number | null,
    itemCondicional?: any,
    valorCondicional?: any,
    checkedCondicional?: boolean,
}

export interface ChecklistSecaoFormData {
    id?: number,
    nome: string,
    draggId: string,
    ordem?: number,
}

export interface OpcoesFormData {
    numero: number,
    descricao: string
}

export interface CampoFormData {
    numero: number,
    label: string,
    tipoCampo: string,
    obrigatorio: boolean
}

export enum SetorTypes {
    COMERCIAL   = 1,
    FINANCEIRO  = 2,
    INFRA       = 3,
    PROJETOS    = 4,
    QUALIDADE   = 5,
}

export enum TipoPerguntaTypes {
    OBJETIVA          = 1,
    DISCURSIVA        = 2,
    MULTIPLA_ESCOLHA  = 3,
    SIM_NAO           = 4,
    // Agrupa varios campos de preenchimento sobre o mesmo assunto; a definicao vai em `config`.
    MULTIPLOS_CAMPOS  = 5,
    // Agrupa varias validacoes marcaveis individualmente; reaproveita `opcoes`.
    CHECKLIST         = 6,
}

// Tipos cuja resposta e composta: so contam como respondidos quando todas as partes
// obrigatorias foram preenchidas (mesma regra de ChecklistItem::isRespostaCompostaCompleta).
export const TIPOS_COMPOSTOS = [TipoPerguntaTypes.MULTIPLOS_CAMPOS, TipoPerguntaTypes.CHECKLIST];

// Tipos que exigem a lista de `opcoes` preenchida no cadastro.
export const TIPOS_COM_OPCOES = [
    TipoPerguntaTypes.MULTIPLA_ESCOLHA,
    TipoPerguntaTypes.OBJETIVA,
    TipoPerguntaTypes.CHECKLIST,
];

export enum TipoCampoTypes {
    TEXTO  = 'texto',
    NUMERO = 'numero',
    DATA   = 'data',
}

export const TipoCampoList = [
    {   value: TipoCampoTypes.TEXTO,  description: 'Texto'   },
    {   value: TipoCampoTypes.NUMERO, description: 'Numero'  },
    {   value: TipoCampoTypes.DATA,   description: 'Data'    },
];

// Finalidade do checklist: Interno e o acompanhamento da equipe de Projetos;
// Externo e o checklist cujo conteudo e levantado junto ao cliente (refs #479035).
export enum TipoChecklistTypes {
    INTERNO = 1,
    EXTERNO = 2,
}

export enum TipoMetrica {
    TEMPO         = 1,
}

export enum AtivoTypes {
    NAO  = 0,
    SIM  = 1,
}

export const AtivoList = new enumDescription(  [
    {   value: AtivoTypes.SIM, description: 'Sim'    },
    {   value: AtivoTypes.NAO, description: 'Não'    },
]);

export const SetorList = new enumDescription(  [
    {   value: SetorTypes.COMERCIAL, description: 'Comercial'    },
    {   value: SetorTypes.FINANCEIRO, description: 'Financeiro'    },
    {   value: SetorTypes.INFRA, description: 'Infra'    },
    {   value: SetorTypes.PROJETOS, description: 'Projetos'    },
    {   value: SetorTypes.QUALIDADE, description: 'Qualidade'    },
]);

export const TipoPerguntaList = new enumDescription(  [
    {   value: TipoPerguntaTypes.OBJETIVA, description: 'Objetiva'    },
    {   value: TipoPerguntaTypes.DISCURSIVA, description: 'Discursiva'    },
    {   value: TipoPerguntaTypes.MULTIPLA_ESCOLHA, description: 'Múltipla Escolha'    },
    {   value: TipoPerguntaTypes.SIM_NAO, description: 'Sim/Não'    },
    {   value: TipoPerguntaTypes.MULTIPLOS_CAMPOS, description: 'Múltiplos Campos'    },
    {   value: TipoPerguntaTypes.CHECKLIST, description: 'Checklist'    }
]);

export const TipoChecklistList = new enumDescription(  [
    {   value: TipoChecklistTypes.INTERNO, description: 'Interno'    },
    {   value: TipoChecklistTypes.EXTERNO, description: 'Externo'    },
]);

export const TipoMetricaList = new enumDescription(  [
    {   value: TipoMetrica.TEMPO, description: 'Tempo de Resposta'    },
]);

export const checklist_content_routes: Array<ContentRoute> = [
    {
        'path':'/checklist',
        'description': 'Checklist',
        'exact':true,
        'component': ChecklistList,
        'menu': true
    },
    {
        'path':'/checklist/incluir',
        'description': 'Incluir Checklist',
        'exact':true,
        'component': ChecklistForm,
        'menu': false
    },
    {
        'path':'/checklist/alterar/:id',
        'description': 'Alterar Checklist',
        'exact':true,
        'component': ChecklistForm,
        'menu': false
    },
    {
        'path':'/checklist/visualizar/:id',
        'description': 'Visualizar Checklist',
        'exact':true,
        'component': ChecklistForm,
        'menu': false
    },
    {
        'path':'/checklist/itens/:id',
        'description': 'Itens do Checklist',
        'exact':true,
        'component': ChecklistItemForm,
        'menu': false
    },
]